import { render, staticRenderFns } from "./MatrizGallery.vue?vue&type=template&id=c76ac3a0&scoped=true"
import script from "./MatrizGallery.vue?vue&type=script&lang=js"
export * from "./MatrizGallery.vue?vue&type=script&lang=js"
import style0 from "./MatrizGallery.vue?vue&type=style&index=0&id=c76ac3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76ac3a0",
  null
  
)

export default component.exports